export default { sha: '3de3fc7cd739cc7a67455b53c02f7a2055974cf1', buildNumber: 'undefined' }
